const BENEFIT_COPY = [
  {
    key: "text.quotebenefit_medical",
    names: ["Travel Medical Insurance Coverage", "Protection d'assurance voyage medicale"]
  },
  {
    key: "text.quotebenefit_tcti",
    names: ["Trip Cancellation", "Annulation de voyage"]
  },
  {
    key: "text.quotebenefit_baggage",
    names: ["Baggage Coverage", "Protection des bagages"]
  }
];

function normalize(value) {
  return String(value || "")
    .replace(/[‘’ʼ]/g, "'")
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .toLowerCase()
    .trim();
}

export default function getQuoteCardBenefitKeys(benefits) {
  const apiNames = (benefits || []).map(benefit => normalize(benefit && benefit.Name));
  return BENEFIT_COPY
    .filter(entry => entry.names.some(name => apiNames.includes(normalize(name))))
    .map(entry => entry.key);
}
